import i18n from "i18next";
import i18nBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const defaultLoadPath =
    typeof window !== "undefined"
        ? `${window.location.origin}/locales/{{lng}}.json`
        : "/locales/{{lng}}.json";

const configuredLocalesBase = (process.env.REACT_APP_LOCALES_BASE_URL || "").replace(/\/$/, "");
const loadPath = configuredLocalesBase
    ? `${configuredLocalesBase}/locales/{{lng}}.json`
    : defaultLoadPath;

i18n
    .use(i18nBackend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        lng: 'en',
        interpolation: {
            escapeValue: false
        },
        backend: {
            loadPath,
        }
    });

export default i18n;